export default __webpack_public_path__ + "static/1860_1870-6d7b1ee3b3145e40a6a56732ba45e36c.mp4";